import { render, staticRenderFns } from "./CreateFormData.vue?vue&type=template&id=1728dc6a&scoped=true"
import script from "./CreateFormData.vue?vue&type=script&lang=js"
export * from "./CreateFormData.vue?vue&type=script&lang=js"
import style0 from "./CreateFormData.vue?vue&type=style&index=0&id=1728dc6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728dc6a",
  null
  
)

export default component.exports